import { render, staticRenderFns } from "./Tab_Dashboard.vue?vue&type=template&id=8cbc6b48&scoped=true"
import script from "./Tab_Dashboard.vue?vue&type=script&lang=js"
export * from "./Tab_Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Tab_Dashboard.vue?vue&type=style&index=0&id=8cbc6b48&prod&lang=css"
import style1 from "./Tab_Dashboard.vue?vue&type=style&index=1&id=8cbc6b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbc6b48",
  null
  
)

export default component.exports